export default "__VITE_ASSET__BTV5xrmN__"